import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {CarouselFtdComponent} from './carousel-ftd.component';
import {IconsModule} from '../icons/icons.module';
import {NewProductCardModule} from '../new-product-card/new-product-card.module';

@NgModule({
  declarations: [CarouselFtdComponent],
  exports: [CarouselFtdComponent],
  imports: [
    CommonModule,
    VirtualScrollerModule,
    NewProductCardModule,
    IconsModule,
    RouterModule,
  ],
})
export class CarouselFtdModule { }
